export enum TranscriptionsMode {
  CAPTION = 'CAPTION',
  LIVE = 'LIVE',
}
